import { selectIsAdminUser, selectIsOfficeStaffUser, selectIsStaffUser } from "../../store/user/user.selector";
import { useSelector } from "react-redux";

import HomeButton from "../../components/home-button";

import CreditCard from "../../pages/credit-card";
import Pix from "../../pages/pix";
import ButtonAppBar from "../../components/global/ToolBar";

import NotFound from "../../pages/notFound";
import PermissionPage from "../../pages/permission";
import AdminPage from "../../pages/admin";
import UsersPage from "../../pages/users";
import UserContractPage from "../../components/users-comps/user-contract";

import { Routes, Route, useLocation } from "react-router-dom";
import "./logged-app.css";

import { useState, useEffect } from "react";

import IndexTerm from "../../components/sign-term";
import { TERMS } from '../../utils/terms-data/term'

import { signOutUser } from "../../utils/firebase/firebase";
import { getContractsSign, addSign } from "../../utils/firebase/firebase.datatable";
import { selectCurrentUser } from "../../store/user/user.selector";

import LoaderPage from '../../components/loader'
import DrawerPage from "../../components/global/Drawer";
import ProdsPage from "../../pages/products";
import SellerPage from "../../pages/seller-page";
import AcertosFuturosPage from "../../pages/acertos-futuros";
import OpenProdsPage from "../../pages/open-prodss";
import SorteiosPage from "../../pages/sorteios";
import AjustesPrecoPage from "../../pages/ajustes-preco";
import TicketCodePage from "../../pages/ticket-code";
import AjustesEstoquePage from "../../pages/ajustes-estoque";
import PesquisarProdutosPage from "../../pages/pesquisar-produtos";
import GerancialVanessaPage from "../../pages/gerencial-vanessa";
import NotasFiscaisPage from "../../pages/nota-fiscal";
import SoldProdsScreen from "../../pages/produtos-vendidos";
import PersonalizedPage from "../../pages/personalizados";
import StockPositionPage from "../../pages/stock/StockPositionPage";
import WarrantiesPage from "../../pages/warranties/WarrantiesPage";
import ProductImagesUploadPage from '../../pages/upload-imgs'
import RankingSellers from "../../pages/ranking-seller";

import GerencialPersonalizedPage from "../../pages/gerencial-personalizados";
import CandidaturePage from '../../pages/candidature-page'


const LoggedApp = () => {
	// #TODO
	const isAdmin = useSelector(selectIsAdminUser);
	const isStaff = useSelector(selectIsStaffUser);
	const isOfficeStarff = useSelector(selectIsOfficeStaffUser);

	const [agree, setAgree] = useState(undefined);
	const [isLoading, setIsLoading] = useState(false);
	const user = useSelector(selectCurrentUser);

	const candidatureAllowedEmails = [
		"financeiro@pitayajoias.com.br",
		"patamarcelo@gmail.com"
	];

	const canAccessCandidatures =
		candidatureAllowedEmails.includes(
			user?.email?.toLowerCase()
		);

	const rankingAllowedEmails = [
		"financeiro@pitayajoias.com.br",
		"patamarcelo@gmail.com",
		"vaabrun@gmail.com"
	];

	const canAccessRankingPage =
		rankingAllowedEmails.includes(
			user?.email?.toLowerCase()
		);

	const location = useLocation(); // React Router hook to get the current location


	const [open, setOpen] = useState(false);

	const toggleDrawer = (newOpen) => () => {
		setOpen(newOpen);
	};

	const handleConfirm = async () => {

		try {
			const newSign = await addSign(
				user.displayName,
				user.email,
				user.uid,
				TERMS
			)
			console.log(newSign)

		} catch (error) {
			console.log('erro ao assinar', error)
		}
		setAgree(true);
	};

	const handleCancel = () => {
		signOutUser();
	};

	const getAllusers = async () => {
		setIsLoading(true)
		try {
			const allUsers = await getContractsSign()
			const confirmArr = allUsers.filter(allUser => allUser.id === user.uid)
			if (confirmArr.length > 0) {
				setAgree(true)
			} else {
				setAgree(false)
			}
			setIsLoading(false)
		} catch (error) {
			console.log('erro em gerar os dados', error)
			signOutUser();
		} finally {
			setIsLoading(false)
		}
	}


	useEffect(() => {
		getAllusers()
	}, [])

	return (
		<div className="logged-app">
			{
				isLoading &&
				<LoaderPage open={isLoading} />
			}
			{agree === false && !isLoading && (
				<>
					<Routes>
						<Route
							path="/"
							element={
								<IndexTerm
									handleConfirm={handleConfirm}
									agree={agree}
									handleCancel={handleCancel}
								/>
							}
						/>
					</Routes>
				</>
			)}
			{agree === true && !isLoading && (
				<>
					<DrawerPage
						toggleDrawer={toggleDrawer}
						open={open}
					/>
					<ButtonAppBar
						toggleDrawer={toggleDrawer}
						open={open}
					/>



					<Routes>
						<Route path="/"
							element={
								isAdmin && isStaff ? <HomeButton /> : <PermissionPage />
							}
						/>
						<Route path="/credit-card" element={<CreditCard />} />
						<Route path="/pix" element={<Pix />} />
						{/* #TODO */}
						<Route
							path="/admin"
							element={
								isAdmin && isStaff ? <AdminPage /> : <PermissionPage />
							}
						/>
						<Route
							path="/notas-fiscais"
							element={
								isAdmin && isStaff ? <NotasFiscaisPage /> : <PermissionPage />
							}
						/>
						<Route
							path="/acertos-futuros"
							element={
								isAdmin && isStaff ? <AcertosFuturosPage /> : <PermissionPage />
							}
						/>
						<Route
							path="/produtos-maletas"
							element={
								isAdmin || isOfficeStarff ? <OpenProdsPage /> : <PermissionPage />
							}
						/>
						<Route
							path="/sorteios"
							element={
								isAdmin && isStaff ? <SorteiosPage /> : <PermissionPage />
							}
						/>
						<Route
							path="/ajustes-preco"
							element={
								isAdmin && isStaff ? <AjustesPrecoPage /> : <PermissionPage />
							}
						/>
						<Route
							path="/ajustes-estoque"
							element={
								isAdmin || isOfficeStarff ? <AjustesEstoquePage /> : <PermissionPage />
							}
						/>
						<Route
							path="/etiquetas"
							element={
								isAdmin && isStaff ? <TicketCodePage /> : <PermissionPage />
							}
						/>
						<Route
							path="/pesquisa-produtos"
							element={
								isAdmin || isOfficeStarff ? <PesquisarProdutosPage /> : <PermissionPage />
							}
						/>

						<Route
							path="/gerencial-vanessa"
							element={
								isAdmin && isStaff ? <GerancialVanessaPage /> : <PermissionPage />
							}
						/>


						<Route
							path="/vendedoras"
							element={
								isAdmin || isOfficeStarff ? <UsersPage /> : <PermissionPage />
							}
						/>
						<Route
							path="/vendedoras/:slug"
							element={<SellerPage />}
						/>
						<Route
							path="/vendedoras/contrato"
							element={
								isAdmin || isOfficeStarff ? <UserContractPage /> : <PermissionPage />
							}
						/>
						<Route
							path="/produtos"
							element={
								isAdmin || isOfficeStarff ? <ProdsPage /> : <PermissionPage />
							}
						/>
						<Route
							path="/produtos-vendidos"
							element={
								isAdmin || isOfficeStarff ? <SoldProdsScreen /> : <PermissionPage />
							}
						/>
						{/* <Route
							path="/produtos-personalizados"
							element={
								isAdmin || isOfficeStarff ? <PersonalizedPage /> : <PermissionPage />
							}
						/> */}
						<Route
							path="/posicao-estoques"
							element={
								isAdmin || isOfficeStarff ? <StockPositionPage /> : <PermissionPage />
							}
						/>
						<Route
							path="/garantias"
							element={
								isAdmin || isOfficeStarff ? <WarrantiesPage /> : <PermissionPage />
							}
						/>
						<Route
							path="/upload-imgs"
							element={
								isAdmin || isOfficeStarff ? <ProductImagesUploadPage /> : <PermissionPage />
							}
						/>
						<Route
							path="/personalizados-gerencial"
							element={
								isAdmin || isOfficeStarff ? <GerencialPersonalizedPage /> : <PermissionPage />
							}
						/>
						<Route
							path="/candidaturas"
							element={
								canAccessCandidatures
									? <CandidaturePage />
									: <PermissionPage />
							}
						/>

						<Route
							path="/ranking-sellers"
							element={
								canAccessRankingPage
									? <RankingSellers />
									: <PermissionPage />
							}
						/>
						<Route path="*" element={<NotFound />} />
					</Routes>

				</>
			)}
		</div>
	);
};

export default LoggedApp;
